import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbScrollSpy, NgbScrollSpyItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent implements OnInit {
  @Input() btnText: string = '';

  @Input() id: string;

  @Input() btnType: string = 'button';

  @Input() btnTitle: string = '';

  @Input() isDisable: boolean = false;

  @Input() isFocus: boolean = false;

  @Input() btnCss: string = '';

  @Input() section: string;

  @Input() scrollSpyItem:
    | NgbScrollSpy
    | string
    | [NgbScrollSpy, string, string?];

  @Input() routerLink: any[] = [];

  @Input() routerLinkActive: string = '';

  @Input() iconSrc: string;

  @ViewChild('childComponent') spanele: HTMLElement;

  @ViewChild('btn') button: ElementRef;

  @Output()
  onBtnClick = new EventEmitter<any>();

  onClick(event: any) {
    this.onBtnClick.emit(event);
  }

  constructor(private elementRef: ElementRef) { }
  ngOnInit() {
    if (Array.isArray(this.scrollSpyItem)) {
      this.section = this.scrollSpyItem[1];
      this.scrollSpyItem = this.scrollSpyItem[0];
    }
  }
  ngAfterViewInit() {
    if (this.isFocus) {
      this.button.nativeElement.focus();
    }
  }
}
